import React, { useEffect, useState } from 'react';
import { Form, FormInstance } from 'antd';
import clsx from 'clsx';
import OrderSwitch from '../../../../Common/Switch';
import SelectSpecialTemperatureMode from '../../../../Common/SelectSpecialTemperatureMode';
import OrderInput from '../../../../Common/Input';
import { FormName } from '../../../../context';
import { ProductFormProps } from '../index';
import SelectBatteryType from './Fields/SelectBatteryType';
import SelectBatteryPackaging from './Fields/SelectBatteryPackaging';

import ShipmentTypeTags from './Fields/ShipmentTypeTags';
import { ClientDataGood } from '../../../../../Adapter';

enum ShipmentTypeEnum {
  dryIce = 'Dry Ice',
  liBa = 'LiBa',
}

interface DHLControlTowerFields extends Omit<ProductFormProps, 'remove'> {
  form: FormInstance;
  // index: number;
}

function DHLControlTowerFields({
  form, index, formName, item,
}: DHLControlTowerFields) {
  // const dangerousGoods = Form.useWatch([formName, index, 'dangerousGoods'], form);
  const isNotRestricted = Form.useWatch([formName, index, 'isNotRestricted'], form);
  // const isRequiredDGD = Form.useWatch([formName, index, 'isRequiredDGD'], form);
  const hasLithiumBattery = Form.useWatch([formName, index, 'hasLithiumBattery'], form);
  const batteryType = Form.useWatch([formName, index, 'batteryType'], form);
  const goodsItem: ClientDataGood = Form.useWatch([formName, index], form);

  return (
    <>
      <h3>
        <span>DHL (DGF FCM Control Tower)</span>
      </h3>

      <ShipmentTypeTags goodsItem={goodsItem} formName={formName} index={index} />

      <OrderSwitch
        rest={item}
        label="NR007 Not Restricted"
        prefix={formName}
        name={[index, 'isNotRestricted']}
      />

      {isNotRestricted && (
        <OrderInput
          rest={item}
          label="Special remark"
          prefix={formName}
          name={[index, 'specialRemark']}
          textarea
          textAreaProps={{
            rows: 1,
            placeholder: 'e.g., This shipment contains lithium-ion batteries contained in equipment...',
          }}
        />
      )}

      <OrderSwitch
        rest={item}
        label="Full DG"
        prefix={formName}
        name={[index, 'isFullDG']}
      />

      <OrderSwitch
        rest={item}
        label="Require DGD"
        prefix={formName}
        name={[index, 'isRequiredDGD']}
      />

      <OrderSwitch
        rest={item}
        label="Lithium Battery"
        prefix={formName}
        name={[index, 'hasLithiumBattery']}
        switchProps={{
          onChange: (checked) => {
            form.setFieldValue([formName, index, 'isRequiredDGD'], checked);
          },
        }}
      />

      {hasLithiumBattery && (
        <>
          <SelectBatteryType
            rest={item}
            label="Battery Type"
            prefix={formName}
            name={[index, 'batteryType']}
            selectProps={{
              onChange: () => {
                form.setFieldValue([formName, index, 'batteryPackaging'], undefined);
              },
            }}
          />
          <SelectBatteryPackaging
            rest={item}
            label="Battery Packaging"
            prefix={formName}
            name={[index, 'batteryPackaging']}
            batteryType={batteryType}
          />
        </>
      )}
    </>
  );
}

export default DHLControlTowerFields;
